import React from 'react';
import PropTypes from 'prop-types';
import styles from './LoadingSpinner.module.css';

export const LoadingSpinner = ({ 
  size = 'medium', 
  color = 'primary',
  className = '' 
}) => {
  const spinnerClasses = [
    styles.spinner,
    styles[size],
    styles[color],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={spinnerClasses}>
      <div className={styles.circle}></div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOf(['primary', 'white', 'gray']),
  className: PropTypes.string
};